import Flex from '../../../components/ui/Flex';
import CardTitle from '../../../components/ui/CardTitle';
import Card from '../../../components/ui/Card';
import { useTotals } from '../../../hooks/useTotals';
import CouponInput from './CouponInput';
import PaymentMethodRadio from './PaymentMethodRadio';
import BuyButton from './BuyButton';
import { useCartStore } from '../../../store/cartStore';
import OrderSummaryLineItem from './OrderSummaryLineItem';
import { proxiesByType } from '@/model/proxyTypes';
import { ShoppingCart } from 'lucide-react';
import { DesktopView, MobileView } from '@fd/frontend/components/responsive';

export default function OrderSummary() {
  const { items, removeItem } = useCartStore();
  const totals = useTotals();

  return (
    <>
      <DesktopView>
        <Card className="sm:w-full sm:max-w-[400px] p-4">
          <Flex.Col className="gap-5 w-full">
            {items.length === 0 && (
              <Flex.Col className="gap-2 items-center p-2.5 text-secondary opacity-50">
                <ShoppingCart className="stroke-secondary h-10 w-10 pb-2" />
                <span>Your cart is empty</span>
                <span>Add proxy services to continue</span>
              </Flex.Col>
            )}
            {items.length > 0 && (
              <OrderSummarySubCard>
                <div className="flex flex-col gap-2 max-h-[340px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                  {items.map((item, index) => (
                    <OrderSummaryLineItem
                      key={item.type}
                      {...item}
                      title={proxiesByType[item.type].title}
                      pricePerUnit={proxiesByType[item.type].price}
                      onRemove={() => removeItem(index)}
                    />
                  ))}
                </div>
              </OrderSummarySubCard>
            )}
            <OrderSummarySubCard>
              <CouponInput />
              <Flex.Row className="justify-between p-2">
                <CardTitle>
                  Total{' '}
                  <span className="text-secondary text-base font-normal">
                    per month:
                  </span>
                </CardTitle>
                <Flex.Row className="gap-2">
                  {totals.isDiscounted && (
                    <CardTitle className="text-muted line-through">
                      <span className="font-normal">
                        {totals.subtotalPriceText}
                      </span>
                    </CardTitle>
                  )}
                  <CardTitle>{totals.totalPriceText} </CardTitle>
                </Flex.Row>
              </Flex.Row>
            </OrderSummarySubCard>
            <PaymentMethodRadio />
            <BuyButton />
          </Flex.Col>
        </Card>
      </DesktopView>
      <MobileView>
        <Flex.Col gap="5">
          {items.map((item, index) => (
            <OrderSummaryLineItem
              key={item.type}
              {...item}
              title={proxiesByType[item.type].title}
              pricePerUnit={proxiesByType[item.type].price}
              onRemove={() => removeItem(index)}
            />
          ))}
          <PaymentMethodRadio />
          <CouponInput />
        </Flex.Col>
      </MobileView>
    </>
  );
}

function OrderSummarySubCard({ children }: { children: React.ReactNode }) {
  return (
    <Card className="px-4 p-2 bg-neutral-100 border-none w-full">
      <Flex.Col className="gap-2">{children}</Flex.Col>
    </Card>
  );
}
